/**
 * Derive whether the current brand/site is "ServiceDrive-only" from Prismic header context.
 *
 * Rationale:
 * - Some brands (e.g., Porsche/Lambo) do not offer guest/account product flows yet.
 * - We do not want a dedicated feature flag; instead, infer capability from the
 *   Prismic header payload (e.g., `product_links`).
 *
 * Contract:
 * - Returns `true` only when we have a definitive signal (empty array).
 * - Returns `false` when links are present.
 * - Returns `null` when header data is not yet available (undefined/null).
 */
export function isServiceDriveOnlyFromHeader(productLinks: unknown): boolean | null {
  if (productLinks == null) return null;
  if (!Array.isArray(productLinks)) return null;
  return productLinks.length === 0;
}

